import type {CreditCardSkinAppearance} from '../types.ts';

export const appearance: CreditCardSkinAppearance = {
    visaLogoColor: '#1A1F71',
    amexLogoColor: '#475467',
    dinersLogoColor: '#25282E',
    jcbLogoColor: '#25282E',
};
